export default function ActionsFooter({
  onMoodClick,
  onSkinClick,
  onFeedbackClick,
  onHelpClick,
}) {
  return (
    <div className="actions">
      <div className="actions__list">
        <a
          href="#!"
          onClick={(event) => {
            event.preventDefault();
            onMoodClick?.();
          }}
        >
          Moods
        </a>
        <a
          href="#!"
          onClick={(event) => {
            event.preventDefault();
            onSkinClick?.();
          }}
        >
          Skins
        </a>
        <a
          href="#!"
          onClick={(event) => {
            event.preventDefault();
            onHelpClick?.();
          }}
        >
          Advanced
        </a>
        <a
          href="#!"
          onClick={(event) => {
            event.preventDefault();
            onFeedbackClick?.();
          }}
        >
          Feedback
        </a>
      </div>
    </div>
  );
}
